import { alpha, styled } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const ODD_OPACITY = 0.2;
export const DataTable = styled(DataGrid)({
  "& .MuiDataGrid-footerContainer": {
    justifyContent: "center",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#fd954f",
    color: "#fff",
    ":hover": {
      backgroundColor: "#fd954f",
    },
  },
  "& .MuiPaginationItem-root": {
    color: "#555",
    "&:hover": {
      backgroundColor: "rgba(253, 149, 79, 0.2)",
    },
  },
  "& .MuiPaginationItem-icon": {
    color: "#555",
  },
  "& .MuiTablePagination-select": {
    color: "#555",
  },
  "& .MuiTablePagination-selectIcon": {
    color: "#555",
  },
  "& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel": {
    color: "#555",
  },
  "& .css-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#fd954f",
    ":hover": {
      backgroundColor: "#fd954f",
    },
  },
  "& .MuiButtonBase-root.MuiButton-root": {
    color: "#fd954f",
  },
  "& .MuiCircularProgress-root": {
    color: "#fd954f !important",
  },
  "& .MuiDataGrid-loadingOverlay .MuiCircularProgress-root": {
    color: "#fd954f !important",
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: "#EEEEEE",
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha("#EEEEEE", ODD_OPACITY),
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    "&.Mui-selected": {
      backgroundColor: alpha("#EEEEEE", ODD_OPACITY),
      "&:hover, &.Mui-hovered": {
        backgroundColor: alpha("#EEEEEE", ODD_OPACITY),
        "@media (hover: none)": {
          backgroundColor: alpha("#EEEEEE", ODD_OPACITY),
        },
      },
    },
  },
  "& .Mui-checked": {
    color: "#fd954f !important",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: 0,
    alignItems: "stretch",
    overflow: "visible",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    padding: 0,
  },
  "& .MuiDataGrid-columnHeaderDraggableContainer": {
    width: "100%",
  },
  // Header-filter tables only: keep the sort arrow out of the layout flow so it
  // overlays the reserved space instead of squeezing the title + filter cell
  // narrower on hover (the column menu is removed via disableColumnMenu).
  "&.with-header-filters .MuiDataGrid-columnHeader": {
    position: "relative",
  },
  "&.with-header-filters .MuiDataGrid-iconButtonContainer": {
    position: "absolute",
    top: 4,
    right: 4,
    width: "auto",
  },
  "& .header-filter-column": {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    minWidth: 0,
  },
  "& .header-filter-title-row": {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 1.2,
    padding: "8px 10px 6px",
    paddingRight: 28,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: "0 0 auto",
  },
  "& .header-filter-row": {
    display: "flex",
    alignItems: "stretch",
    flex: "1 1 auto",
    borderTop: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: "#fafafa",
    minHeight: 40,
    overflow: "visible",
  },
  "& .header-filter-cell-root": {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
    height: "100%",
    boxSizing: "border-box",
    padding: "4px 6px",
    gap: 4,
    transition: "background-color 120ms ease, box-shadow 120ms ease",
  },
  // Active = a left accent bar + light fill (non-color cue paired with the orange).
  "& .header-filter-cell-root.is-active": {
    backgroundColor: "rgba(253, 149, 79, 0.07)",
    boxShadow: "inset 3px 0 0 #fd954f",
  },
  // Narrow columns: stack the operator chip above the value row so the same
  // labelled chip stays usable rather than swapping to a different control.
  "& .header-filter-cell-root.compact": {
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    gap: 3,
  },
  "& .header-filter-cell-root.compact .header-filter-operator-chip": {
    alignSelf: "flex-start",
    maxWidth: "100%",
  },
  "& .header-filter-value-row": {
    display: "flex",
    alignItems: "center",
    gap: 4,
    flex: "1 1 auto",
    minWidth: 0,
    width: "100%",
  },
  "& .header-filter-operator-chip": {
    flex: "0 0 auto",
    minWidth: 0,
    maxWidth: 130,
    height: 26,
    padding: "0 2px 0 8px",
    borderRadius: 13,
    fontSize: 12,
    lineHeight: 1.2,
    textTransform: "none",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: "rgba(0, 0, 0, 0.6)",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    "& .MuiButton-endIcon": {
      marginLeft: -2,
      marginRight: -4,
    },
    "& .MuiButton-endIcon > svg": {
      fontSize: 18,
    },
    "&:hover": {
      backgroundColor: "rgba(253, 149, 79, 0.12)",
      borderColor: "#fd954f",
      color: "#d9772f",
    },
  },
  "& .header-filter-operator-chip.is-active": {
    backgroundColor: "#fd954f",
    borderColor: "#fd954f",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#f3863a",
      borderColor: "#f3863a",
      color: "#fff",
    },
  },
  "& .header-filter-value-wrap": {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    height: 30,
    padding: "0 6px",
    borderRadius: 6,
    border: "1px solid rgba(0, 0, 0, 0.12)",
    backgroundColor: "#fff",
    transition: "border-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: "rgba(253, 149, 79, 0.6)",
    },
    "&:focus-within": {
      borderColor: "#fd954f",
      boxShadow: "0 0 0 2px rgba(253, 149, 79, 0.18)",
    },
  },
  "& .header-filter-value-input": {
    width: "100%",
    fontSize: 13,
    "& .MuiInputBase-input": {
      padding: "4px 0",
      fontSize: 13,
    },
    "& .MuiSelect-select": {
      padding: "4px 0",
      fontSize: 13,
    },
    // Kill the standard-variant underline (DatePicker text field).
    "& .MuiInput-root:before, & .MuiInput-root:after": {
      display: "none",
    },
  },
  "& .header-filter-no-value": {
    flex: "1 1 auto",
    minWidth: 0,
    fontSize: 12,
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.38)",
    paddingLeft: 2,
    userSelect: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .header-filter-clear-button": {
    flex: "0 0 auto",
    width: 24,
    height: 24,
    color: "rgba(0, 0, 0, 0.5)",
    "&:hover": {
      color: "#d9772f",
    },
  },
});
